<template>
  <div class="errorPage">
    <v-img
      src="../assets/notFound/not-found-bymond-free-tools.svg"
      class="mt-1"
      width="40%"
    ></v-img>
    <h1 class="secondary--text lighten-4 mt-4">Page Not Found !</h1>

    <v-btn @click="goBack()" class="px-5 py-6 mt-5 secondary">
      <v-icon small class="mr-2">
        mdi-arrow-left
      </v-icon>    Go Back
    </v-btn>
  </div>
</template>

<script>
import headValues from "../helpers/headValues";
export default {
  name: "NotFoundPage",

  methods:{
    goBack(){
      this.$router.go(-1)
    },

    


  },






  head: {
    title: headValues.title("Page Not Found"),
    // // Meta tags
    meta: headValues.meta(
      "Page Not Found",
      "Page Not Found",
      "Page Not Found"
    ),
    // link tags
    link: headValues.link("/404"),
  },

};
</script>


<style scoped lang="scss">
* {
  padding: 0 !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

.errorPage {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
